module.exports = __webpack_public_path__ + "static/img/zj_course_selection_widget_1.5ccc609.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/homepage/img/zj_course_selection_widget_1.png
// module id = qY+C
// module chunks = 11